import angular from 'angular';

import Component from './coupon-details.component';

const CouponDetails = angular
    .module('control-room.experience-promoter.components.coupon-details', [])
    .component('crCouponDetails', Component);

export default CouponDetails;
